import { orderSpaceType } from "components/constants/DropdownOptions";
import React from "react";
import { Col, Row } from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import { useTranslation } from "react-i18next";
import Chair from "assets/images/icons/chair.svg";
import Riyal from "assets/images/icons/riyal.svg";
import Building from "assets/images/icons/building.svg";
import User from "assets/images/icons/userBlack.svg";
import Leaf from "assets/images/icons/leafBlack.svg";

const OverviewRevenueCard = ({ item }) => {
  const { t } = useTranslation();

  return (
    <Col md={4} style={{ padding: "0 6.5px" }}>
      <div className="inner_section">
        <div className="g_between">
          <h2 className="fs_20 text_black">
            {t(
              orderSpaceType?.find(
                (option) => option.value === item?.spaceTypeInt
              )?.name
            ) || "-"}
          </h2>
          <div className="total_bookings">
            <img src={Chair} alt="char" width={15} height={15} />
            <p className="fs_12 text_dark_gray">
              {t("Total Bookings")}:{" "}
              <span className="fs_14 text_black">
                {" "}
                {item?.totalBookings ?? "-"}
              </span>
            </p>
          </div>
        </div>
        <h3 className="fs_12 text_dark_gray">{t("Total Revenue")}</h3>
        <h2 className="fs_40 text_black">
          <img
            src={Riyal}
            width={25}
            height={27}
            alt="riyal"
            className="me-1"
          />
          {item?.totalRevenue?.toLocaleString("en-US")}
        </h2>
        <div className="occupancy_inner">
          <div className="d-flex gap-2">
            <img src={Building} alt="icon" width={15} height={15} />
            <p className="fs_12 text_dark_gray">{t("Occupancy Rate:")}</p>
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <p className="fs_14 text_black">{item?.occupancyRate ?? 0}%</p>
              <div className="custom_progressbar">
                <ProgressBar now={item?.occupancyRate} />
              </div>
            </div>
          </div>
          <div className="d-flex gap-2">
            <p className="fs_12 text_dark_gray">
              {t("Expected Revenue at 100% Occupancy:")}
            </p>
            <div className="d-flex align-items-center">
              <img
                src={Riyal}
                width={10}
                height={11}
                alt="icon"
                className="mx-1"
              />
              <h2 className="fs_14 text_black">
                {" "}
                {item?.fullOccupancyRevenue?.toLocaleString("en-US")}
              </h2>
            </div>
          </div>
        </div>
        {/* SHOW COMMISSION FOR WORKSHOPS */}
        {item?.spaceTypeInt === 3 && (
          <div className="d-flex commission_inner">
            <div className="single_commission ">
              <img src={User} alt="user" width={15} height={15} />
              <div>
                <h2 className="fs_12 text_dark_gray">
                  {t("Trainer commission")}
                </h2>
                <div className="d-flex align-items-center gap-1">
                  <img src={Riyal} width={10} height={11} alt="" />
                  <h2 className="fs_14 text_black">
                    {item?.trainerShare?.toLocaleString("en-US")}
                  </h2>
                </div>
              </div>
            </div>
            <div className="single_commission ">
              <img
                src={Leaf}
                alt="user"
                width={10}
                height={9}
                className="mt-1"
              />
              <div>
                <h2 className="fs_12 text_dark_gray">
                  {t("Ashjar commission")}
                </h2>
                <div className="d-flex align-items-center gap-1">
                  <img src={Riyal} width={10} height={11} alt="" />
                  <h2 className="fs_14 text_black">
                    {item?.companyShare?.toLocaleString("en-US")}
                  </h2>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* <Row className="mt-5">
          <Col lg={6}>
            <div className="l_section">
              <h2 className="fs_14 text_gray">{t("Total Revenue")}</h2>
              <h3 className="fs_40">
                {item?.totalRevenue?.toFixed(2)}
                <span className="fs_14 text_black">{t("SR")}</span>
              </h3>
              <p className="fs_14 d-flex text_gray">
                {t("Total Bookings:")}{" "}
                <span className="mx-1 text_primary">
                  {item?.totalBookings || "-"}
                </span>
              </p>
            </div>
          </Col>
          <Col lg={6}>
            <div className="r_section">
              <h2 className="fs_20 text_black">
                {t(
                  orderSpaceType?.find(
                    (option) => option.value === item?.spaceTypeInt
                  )?.name
                ) || "-"}
              </h2>
              <h3 className="fs_14 text_gray">{t("Occupancy Rate")}</h3>
              <div className="fs_14 d-flex">
                <span className="mx-1 text_primary">
                  {item?.occupancyRate ?? 0}%
                </span>
                <div className="w-100 custom_progressbar">
                  <ProgressBar
                    now={item?.occupancyRate}
                    className="mt-2 mx-1"
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row> */}
      </div>
    </Col>
  );
};

export default OverviewRevenueCard;
